import { Stack } from 'expo-router';
import React from 'react';

export default function PhoneBattlePlanLayout() {
  return (
    <Stack>
      <Stack.Screen name="index" />
      <Stack.Screen name="[engagementId]" options={{ headerShown: false }} />
    </Stack>
  );
}
